import { createContext, useContext } from 'react';
import { IPubliclyAvailableFilesContext } from '@vivli/features/studies/infrastructure/interface';
export const PubliclyAvailableFilesContext = createContext<IPubliclyAvailableFilesContext>(null);

export const usePubliclyAvailableFiles = () => useContext(PubliclyAvailableFilesContext);
